module.exports = __webpack_public_path__ + "img/load-spinner.709d2dc2.png";